import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export class TimeoutService {
   startTime: Date; // timestamp when page first loads
   static $inject = ['$state'];

   constructor(
      private $state:uir.StateService,) {
   }
   
   startSession() {
      this.startTime = new Date();
   }

   checkSession() {
      const timeDifference = new Date().getTime() - this.startTime.getTime() ;
      const timeDifferenceInMinutes = timeDifference / (1000 * 60);
      if (timeDifferenceInMinutes > 15) {
         this.$state.go('shell.timeout');
         return false;
      }
      return true;
   }
}

ng.module('selfReg')
   .service('timeoutService', TimeoutService);
